import React from "react";
import { withRouter } from "react-router-dom";
import LoadSpinner from "../../common/spinner/loadSpinner";
import Menucustom from "../../common/menu/menucustom";
import DashboardSanzioneService from "../dashboard/dashboardSanzione/dashboardSanzioneService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  getColorState,
  capitalizeFirstLetter,
  validCF,
  getFormatOraInput
} from "../../common/utils";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import { CSVLink, CSVDownload } from "react-csv";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import externalLink from './export.png'
import BootstrapSwitchButton from "bootstrap-switch-button-react";

toast.configure();

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorCFTrasgessorePotesta: false,
      errorCFTrasgessore: false,
      data: [],
      dataTableSanzione: [],
      dataTableSanzioneCSV: [],
      dataTableSanzioneCSVLoad: "",
      headerDataTableSanzione: [],
      searchNumSanzione: "",
      searchDataEmissione: "",
      searchNome: "",
      idSanzionePerToast:0,
      searchCognome: "",
      searchCF: "",
      loading: true,
      showModalAggiungiSanzione: false,
      anagraficaSanzionato: false,
      isMinorenne: false,
      documentiSanzionati: false,
      residenzaSanzioanto: false,
      anagraficaSanzionatoPatriaPotesta: false,
      renderTableDataReload: false,
      dettagliSanzione: false,
      allegati: false,
      buttonCreaSanzione: true,

      nomeSanzionatoRequired: false,
      cognomeSanzionatoRequired: false,
      comuneDiResidenzaSanzionatoRequired: false,
      indirizzoSanzionatoRequired: false,
      provinciaSanzionatoRequired: false,
      capSanzionatoRequired: false,
      numeroResidenzaSanzionatoRequired: false,

      nomeSanzionatoPatriaPotestaRequired: false,
      cognomeSanzionatoPatriaPotestaRequired: false,
      comuneDiResidenzaSanzionatoPatriaPotestaRequired: false,
      indirizzoSanzionatoPatriaPotestaRequired: false,
      provinciaSanzionatoPatriaPotestaRequired: false,
      capSanzionatoPatriaPotestaRequired: false,
      numeroResidenzaSanzionatoPatriaPotestaRequired: false,

      rateScadute: [],

      tipologieSanzioni: [],
      /*locationsList: [
        {
          idLocalita: 0,
          nomeLocalita: "",
          idLinea: 0,
          idArea: 0,
          idCliente: 0,
          importo: 0,
        },
      ],*/
      sexList: [
        "M",
        "F"
      ],
      inspectorsList: [
        {
          nome: "",
          cognome: "",
          numMatricola: "",
          email: "",
        }
      ],
      creaSanzione: {
        anagraficaTrasgressore: {
          nome: "",
          cognome: "",
          sesso: "",
          dataDiNascita: "",
          luogoDiNascita: "",
          isMinorenne: 0,
          numeroDocumento: "",
          dataRilascioDocumento: "",
          enteRilascioDocumento: "",
          comuneDiResidenza: "",
          inidirizzoDiResidenza: "",
          inidirizzoNumeroDiResidenza: "",
          provinciaDiResidenza: "",
          capDiResidenza: "",
          codiceFiscale: "",
        },
        anagraficaPotestaTrasgressore: {
          nome: "",
          cognome: "",
          sesso: "",
          dataDiNascita: "",
          luogoDiNascita: "",
          isMinorenne: 0,
          numeroDocumento: "",
          dataRilascioDocumento: "",
          enteRilascioDocumento: "",
          comuneDiResidenza: "",
          inidirizzoDiResidenza: "",
          inidirizzoNumeroDiResidenza: "",
          provinciaDiResidenza: "",
          capDiResidenza: "",
          codiceFiscale: "",
        },
        anagraficaTipologiaSanzione:"",
        localita: "",
        anagraficaStati: { idStato: 1, nomeStato: "caricato" },
        matricolaControllore: "",
        lineaMezzo:"",
        numeroSanzione:"",
        importo: 0,
        importoRidotto: 0,
        importoTitoloDiViaggio:0,
        lat:0.0,
        lng:0.0,
        dataDiEmissione:"",
        annotazioneControllore: "",
        noteTrasgressore: "",
        pagataABordo: false,
        clienti:{
          idCliente: 1,
          attivo: 1,
        },
        spacchettato:""
      },
      spacchettato:{
        //METCALC:"MC1",
        SZ_RID:0,
        SZ:0,
        SZ_INT:0,
      },
      filtro: {
        dataInizio: "",
        dataFine: "",
      },
      showModalConfermaSanzione: false,
      loadingButton:false,
    };
    this.geDataFormat = geDataFormat.bind(this);
    this.getColorState = getColorState.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.csvLinkEl = React.createRef();
    this.nameRegex = new RegExp("^[A-Za-zÀ-ÖØ-öø-ÿ']{2,}(?: [A-Za-zÀ-ÖØ-öø-ÿ']+)*$");
    this.sanzioneValueRegex = new RegExp("^[0-9]+(\\,[0-9]+)?$")
  }

  componentDidMount() {
    toast.dismiss();
    this.dashboardSanzioneService = new DashboardSanzioneService();
    var search = this.props.location.search;
    var stato = "daLav";

    this.dashboardSanzioneService.getSettings((result)=>{
      result.forEach((opzioni)=>{
        if(opzioni.key === "SZ_RID"){
          this.setState({spacchettato:{...this.state.spacchettato,SZ_RID:parseFloat(opzioni.value)}})
        }
        if(opzioni.key === "SZ"){
          this.setState({spacchettato:{...this.state.spacchettato,SZ:parseFloat(opzioni.value)}})
        }
        if(opzioni.key === "SZ_INT"){
          this.setState({spacchettato:{...this.state.spacchettato,SZ_INT:parseFloat(opzioni.value)}})
        }
      })
    })

    var filtroDate = JSON.parse(sessionStorage.getItem("filtroDate"));

    if (filtroDate) {
      this.state.filtro = filtroDate;
      sessionStorage.removeItem("filtroDate");
    } else {
      this.state.filtro.dataFine = moment(new Date()).format("YYYY-MM-DD")
      this.state.filtro.dataInizio = moment(this.state.filtro.dataFine, "YYYY-MM-DD").subtract(29, "d").format("YYYY-MM-DD")
    }

    if (search != null && search.includes("?")) {
      stato = search.substring(1, search.lenght);
    }

    this.getDataTable(
      stato,
      this.state.filtro.dataInizio,
      this.state.filtro.dataFine
    );

    if (stato === "rateizzati") {
      this.dashboardSanzioneService.getRateScadute((result) => {
        this.setState({ rateScadute: result.data });
        result.data.map((val) => {
        this.stringRateizza = <>Numero Sanzione: {val.toString()} <br/></>;
        this.strgss = this.strgss + this.stringRateizza;
        this.stringRateizza = this.stringRateizza.toString() + this.stringRateizza.toString();
        
        if (result.data.length <= 3) {
          toast.warning(<><span style={{fontSize:13}}>Numero sanzione con rata/e scadute:</span> <br></br><a onClick={()=>{
            // this.state.dataTableSanzione.map(valore => {
            //   if(valore.numeroSanzione === val){
            //     // this.state.idSanzionePerToast =valore.id;
            //     this.statoOnClickSanzione = {
            //       id:valore.id,
            //       statoSanzione:"Rateizzato",
            //     }
            //     sessionStorage.removeItem("rowSanzione");
            //     sessionStorage.setItem("rowSanzione", JSON.stringify(this.statoOnClickSanzione));
            
            //     // sessionStorage.removeItem("filtroDate");
            //     // sessionStorage.setItem("filtroDate", JSON.stringify(this.state.filtro));
            
            //     // this.props.history.push("/detailSanzione");
            //   }
            //   this.props.history.push("/detailSanzione");
            // })
            this.dashboardSanzioneService.getIdSanzioneByNumSanzione(val, (result) => {
              var detail = {
                id: result.data,
                statoSanzione:"Rateizzato",
              };
              sessionStorage.removeItem("rowSanzione");
              sessionStorage.setItem("rowSanzione", JSON.stringify(detail));
              toast.dismiss();
              this.props.history.push("/detailSanzione");
            })
          }}> {val} <img src={externalLink}  width={15} height={15}/></a></>, {
            autoClose: 50000,
            hideProgressBar: true,
            closeOnClick: true,
            style:{width:"100%"},
            
          });
        }
        if (result.data.length > 3) {
          toast.error(
             <><span style={{fontSize:13}}>Numero sanzione con rata/e scadute:</span> <br></br><a onClick={()=>{
              this.dashboardSanzioneService.getIdSanzioneByNumSanzione(val, (result) => {
                var detail = {
                  id: result.data,
                  statoSanzione:"Rateizzato",
                };
                sessionStorage.removeItem("rowSanzione");
                sessionStorage.setItem("rowSanzione", JSON.stringify(detail));
                toast.dismiss();
                this.props.history.push("/detailSanzione");
              })
             }}><u>{val}</u> <img src={externalLink} width={15} height={15} /></a><br></br></>
          , {
            autoClose: 50000,
            hideProgressBar: true,
            closeOnClick: true,
            style:{width:"100%"},
            // onClick:()=>{
            //   // this.state.dataTableSanzione.map(valore => {
            //   //   if(valore.numeroSanzione === val){
            //   //     // this.state.idSanzionePerToast =valore.id;
            //   //     this.statoOnClickSanzione = {
            //   //       id:valore.id,
            //   //       statoSanzione:"Rateizzato",
            //   //     }
            //   //     sessionStorage.removeItem("rowSanzione");
            //   //     sessionStorage.setItem("rowSanzione", JSON.stringify(this.statoOnClickSanzione));
              
            //   //     // sessionStorage.removeItem("filtroDate");
            //   //     // sessionStorage.setItem("filtroDate", JSON.stringify(this.state.filtro));
              
            //   //   }
            //   //   this.props.history.push("/detailSanzione");
            //   // })
            //   // this.statoOnClickSanzione = {
            //   //   id:this.state.idSanzionePerToast,
            //   //   statoSanzione:"Rateizzato",
            //   // }
            //   // sessionStorage.removeItem("rowSanzione");
            //   // sessionStorage.setItem("rowSanzione", JSON.stringify(this.statoOnClickSanzione));
          
            //   // // sessionStorage.removeItem("filtroDate");
            //   // // sessionStorage.setItem("filtroDate", JSON.stringify(this.state.filtro));
          
            //   // this.props.history.push("/detailSanzione");
            //   this.dashboardSanzioneService.getIdSanzioneByNumSanzione(val, (result) => {
            //     var detail = {
            //       id: result.data,
            //       statoSanzione:"Rateizzato",
            //     };
            //     sessionStorage.removeItem("rowSanzione");
            //     sessionStorage.setItem("rowSanzione", JSON.stringify(detail));
            //     toast.dismiss();
            //     this.props.history.push("/detailSanzione");
            //   })
            // }
          });
        }
        });

      });
       
      }
    }
    

    // this.getExportCSV(stato);

  getTipologiaMulte() {
    this.dashboardSanzioneService.getTipoSanzione(
      this.onSuccesGetSanzioni.bind(this)
    );
  }

  getExportCSV(stato) {
    this.dashboardSanzioneService.getExportCSV(
      stato,
      this.state.filtro.dataInizio,
      this.state.filtro.dataFine,
      this.onSuccesExportCSV.bind(this)
    );
  }
  // (dati.importo / 100).toFixed(2),
  onSuccesExportCSV(result) {
    //primi campi del CSV
    if(result.data.length <= 0){
      toast.error("Non ci sono record da esportare")
    }else {
      this.setState({dataTableSanzioneCSV:[]});
      result.data.map((dati) => {
        // console.log(dati.anagraficaTrasgressore.dataRilascioDocumento);
  
        if (
          dati.anagraficaTrasgressore.dataRilascioDocumento === null ||
          dati.anagraficaTrasgressore.dataRilascioDocumento === ""
        ) {
          this.dataRilascioDocumento = "";
        } else {
          this.dataRilascioDocumento = geDataFormat(
            dati.anagraficaTrasgressore.dataRilascioDocumento
          );
          // new Date(
          //   dati.anagraficaTrasgressore.dataRilascioDocumento
          // ).getDate() +
          // "/" +
          // new Date(
          //   dati.anagraficaTrasgressore.dataRilascioDocumento
          // ).getMonth() +
          // "/" +
          // new Date(
          //   dati.anagraficaTrasgressore.dataRilascioDocumento
          // ).getFullYear() +
          // " " +
          // new Date(
          //   dati.anagraficaTrasgressore.dataRilascioDocumento
          // ).getHours() +
          // ":" +
          // new Date(
          //   dati.anagraficaTrasgressore.dataRilascioDocumento
          // ).getMinutes();
        }
        if (
          dati.anagraficaPotestaTrasgressore.dataDiNascita === null ||
          dati.anagraficaPotestaTrasgressore.dataDiNascita === ""
        ) {
          this.anagraficaPotestaTrasgressoreDataDiNascita = "";
        } else {
          this.anagraficaPotestaTrasgressoreDataDiNascita = geDataFormat(
            dati.anagraficaPotestaTrasgressore.dataDiNascita
          );
          // new Date(dati.anagraficaPotestaTrasgressore.dataDiNascita).getDate() +
          // "/" +
          // new Date(
          //   dati.anagraficaPotestaTrasgressore.dataDiNascita
          // ).getMonth() +
          // "/" +
          // new Date(
          //   dati.anagraficaPotestaTrasgressore.dataDiNascita
          // ).getFullYear() +
          // " " +
          // new Date(
          //   dati.anagraficaPotestaTrasgressore.dataDiNascita
          // ).getHours() +
          // ":" +
          // new Date(
          //   dati.anagraficaPotestaTrasgressore.dataDiNascita
          // ).getMinutes();
        }
        if (
          dati.anagraficaPotestaTrasgressore.dataRilascioDocumento === null ||
          dati.anagraficaPotestaTrasgressore.dataRilascioDocumento === ""
        ) {
          this.anagraficaPotestaTrasgressoreDataRilascioDocumento = "";
        } else {
          this.anagraficaPotestaTrasgressoreDataRilascioDocumento = geDataFormat(
            dati.anagraficaPotestaTrasgressore.dataRilascioDocumento
          );
          // new Date(
          //   dati.anagraficaPotestaTrasgressore.dataRilascioDocumento
          // ).getDate() +
          // "/" +
          // new Date(
          //   dati.anagraficaPotestaTrasgressore.dataRilascioDocumento
          // ).getMonth() +
          // "/" +
          // new Date(
          //   dati.anagraficaPotestaTrasgressore.dataRilascioDocumento
          // ).getFullYear() +
          // " " +
          // new Date(
          //   dati.anagraficaPotestaTrasgressore.dataRilascioDocumento
          // ).getHours() +
          // ":" +
          // new Date(
          //   dati.anagraficaPotestaTrasgressore.dataRilascioDocumento
          // ).getMinutes();
        }
  
        this.state.dataTableSanzioneCSV = [
          ...this.state.dataTableSanzioneCSV,
          {
            idSanzione: dati.idSanzione,
            numeroSanzione: dati.numeroSanzione,
            lineaMezzo: dati.lineaMezzo,
            matricolaControllore: dati.matricolaControllore,
            importo: (dati.importo / 100).toFixed(2),
            dataDiEmissione: geDataFormat(dati.dataDiEmissione),
            // new Date(dati.dataDiEmissione).getDate() +
            // "/" +
            // new Date(dati.dataDiEmissione).getMonth() +
            // "/" +
            // new Date(dati.dataDiEmissione).getFullYear() +
            // " " +
            // new Date(dati.dataDiEmissione).getHours() +
            // ":" +
            // new Date(dati.dataDiEmissione).getMinutes(),
            annotazioneControllore: dati.annotazioneControllore,
            noteTrasgressore: dati.noteTrasgressore,
            pagataABordo: dati.pagataABordo,
            nomeViolazione: dati.anagraficaTipologiaSanzione.nomeViolazione,
            nomeStato: dati.anagraficaStati.nomeStato,
            idAnagraficaTrasgressore:
              dati.anagraficaTrasgressore.idAnagraficaTrasgressore,
            nomeTrasgressore: dati.anagraficaTrasgressore.nome,
            cognomeTrasgressore: dati.anagraficaTrasgressore.cognome,
            codiceFiscaleTrasgressore: dati.anagraficaTrasgressore.codiceFiscale,
            dataDiNascitaTrasgressore: this.dataRilascioDocumento,
            luogoDiNascitaTrasgressore:
              dati.anagraficaTrasgressore.luogoDiNascita,
            isMinorenneTrasgressore: dati.anagraficaTrasgressore.isMinorenne,
            numeroDocumentoTrasgressore:
              dati.anagraficaTrasgressore.numeroDocumento,
            enteRilascioDocumentoTrasgressore:
              dati.anagraficaTrasgressore.enteRilascioDocumento,
            inidirizzoDiResidenzaTrasgressore:
              dati.anagraficaTrasgressore.inidirizzoDiResidenza,
            inidirizzoNumeroDiResidenzaTrasgressore:
              dati.anagraficaTrasgressore.inidirizzoNumeroDiResidenza,
            capDiResidenzaTrasgressore:
              dati.anagraficaTrasgressore.capDiResidenza,
            provinciaDiResidenzaTrasgressore:
              dati.anagraficaTrasgressore.provinciaDiResidenza,
            idAnagraficaPotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.idAnagraficaTrasgressore,
            nomePotestaTrasgressore: dati.anagraficaPotestaTrasgressore.nome,
            cognomePotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.cognome,
            codiceFiscalePotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.codiceFiscale,
            dataDiNascitaPotestaTrasgressore:
              this.anagraficaPotestaTrasgressoreDataDiNascita,
            luogoDiNascitaPotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.luogoDiNascita,
            isMinorennePotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.isMinorenne,
            numeroDocumentoPotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.numeroDocumento,
            dataRilascioDocumentoPotestaTrasgressore:
              this.anagraficaPotestaTrasgressoreDataRilascioDocumento,
            enteRilascioDocumentoPotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.enteRilascioDocumento,
            inidirizzoDiResidenzaPotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.inidirizzoDiResidenza,
            inidirizzoNumeroDiResidenzaPotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza,
            capDiResidenzaPotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.capDiResidenza,
            provinciaDiResidenzaPotestaTrasgressore:
              dati.anagraficaPotestaTrasgressore.provinciaDiResidenza,
          },
        ];
      });
      // console.log(this.state.dataTableSanzioneCSV);
      this.setState(
        {
          dataTableSanzioneCSVLoad: this.state.dataTableSanzioneCSV,
        },
        () => {
          setTimeout(() => {
            this.csvLinkEl.current.link.click();
          });
        }
      );
    }

    
    // console.log(result.data);
  }

  onClickCSVDownLoad() {
    var search = this.props.location.search;
    var stato = "daLav";
    if (search != null && search.includes("?")) {
      stato = search.substring(1, search.lenght);
    }
    this.getExportCSV(stato);
    this.csvLink.current.link.click();
    // console.log(this.csvLink.current.link)
  }

  onSuccesGetSanzioni(result) {
    // console.log(result.data);
    this.setState((this.state.tipologieSanzioni = result.data));
  }

  onSuccesCreateSanzione(result) {
    // alert(result.data);
    // console.log(result);
    if (result.status === 200) {
      this.setState({
        showModalAggiungiSanzione: false,
        renderTableDataReload: true,
      });
      toast.success("Sanzione creata con successo", {
        position: toast.POSITION.TOP_RIGHT,
      });
      this.setState({
        showModalAggiungiSanzione: false,
        anagraficaSanzionato: false,
        isMinorenne: false,
        documentiSanzionati: false,
        residenzaSanzioanto: false,
        anagraficaSanzionatoPatriaPotesta: false,
        dettagliSanzione: false,
        buttonCreaSanzione: true,
        nomeSanzionatoRequired: false,
        cognomeSanzionatoRequired: false,
      });
      this.state.creaSanzione.importo = 0;
      var search = this.props.location.search;
      var stato = "daLav";
      if (search != null && search.includes("?")) {
        stato = search.substring(1, search.lenght);
      }
      this.getDataTable(
        stato,
        this.state.filtro.dataInizio,
        this.state.filtro.dataFine
      );
      this.state.creaSanzione.importo = 0;
      this.state.creaSanzione.annotazioneControllore = "";
      this.state.creaSanzione.noteTrasgressore = "";
      this.state.creaSanzione.anagraficaTrasgressore.dataDiNascita = "";
      this.state.creaSanzione.anagraficaTrasgressore.luogoDiNascita = "";
      this.state.creaSanzione.anagraficaTrasgressore.nome = "";
      this.state.creaSanzione.anagraficaTrasgressore.cognome = "";
      this.state.creaSanzione.anagraficaTrasgressore.capDiResidenza = "";
      this.state.creaSanzione.anagraficaTrasgressore.inidirizzoDiResidenza = "";
      this.state.creaSanzione.anagraficaTrasgressore.isMinorenne = 0;
      this.state.creaSanzione.anagraficaTrasgressore.numeroDocumento = "";
      this.state.creaSanzione.anagraficaTrasgressore.dataRilascioDocumento = "";
      this.state.creaSanzione.anagraficaTrasgressore.enteRilascioDocumento = "";
      this.state.creaSanzione.anagraficaTrasgressore.inidirizzoNumeroDiResidenza =
        "";
      this.state.creaSanzione.anagraficaTrasgressore.provinciaDiResidenza = "";
      this.state.creaSanzione.anagraficaTrasgressore.codiceFiscale = "";
      this.state.creaSanzione.anagraficaTrasgressore.comuneDiResidenza = "";

      this.state.creaSanzione.anagraficaPotestaTrasgressore.nome = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.cognome = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.dataDiNascita = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.isMinorenne = 0;
      this.state.creaSanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.comuneDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.capDiResidenza = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.luogoDiNascita = "";
    } else {
      toast.error(
        "Qualcosa è andato storto durante la creazione della sanzione",
        { position: toast.POSITION.TOP_RIGHT }
      );
    }
  }
  getDataTable(stato, dataInizio, dataFine) {
    this.dashboardSanzioneService.getDataTableSanzioni(
      stato,
      dataInizio,
      dataFine,
      this.onSuccessLoadDataTableSanzione.bind(this)
    );
  }

  onSuccessLoadDataCharter(result) {
    this.setState((this.data = result));
  }
  onSuccessLoadDataTableSanzione(resultHeader, resultBody) {
    var sanzioni = resultBody;
    var numSanzioniInscadenza = 0;
    var numSanzioniMancanoDieciGiorni = 0;
    for (let i = 0; i < sanzioni.length; i++) {
      var sanzione = sanzioni[i];
      sanzione.importo = (sanzione.importo / 100).toFixed(2).toString().replace(".", ",") + " €"
      if(sanzione.minorenne){
        sanzione.minorenne = "Minorenne"
      }else{
        sanzione.minorenne = "Maggiorenne"
      }
      var allaScadenza = "-";
      if ("Caricato" === sanzioni[i].statoSanzione) {
        // console.log(sanzione);
        var diff = calculateTimeDifferenceTwoDates(
          new Date(),
          moment(sanzione.dataEmissione, "DD/MM/YYYY").toDate()
        );

        // allaScadenza = 60 - parseInt(diff, 10);
        // allaScadenza = 60 - parseInt(diff, 10);
        // if(new Date() === parseInt(diff, 10) ){
        // }

        var giorniAllaScadenza = parseInt(diff);
        allaScadenza = 60 - giorniAllaScadenza;

        if (
          parseInt(diff) >= 50 ||
          parseInt(diff) >= 55 ||
          parseInt(diff) >= 46
        ) {
          numSanzioniMancanoDieciGiorni += 1;
        }

        var val = "-";
        if (allaScadenza < 0) {
          val = "Scaduto";
          // numSanzioniInscadenza += 1;
        } else {
          val = "Scade tra " + allaScadenza + " giorni";
          if (allaScadenza < 5) numSanzioniInscadenza += 1;
        }

        if (allaScadenza <= 10) {
          // numSanzioniMancanoDieciGiorni += 1;
          // console.log(allaScadenza + " " + "simone");
        }
        sanzione.giorniAllaScadenza = val;
        // console.log(sanzione.giorniAllaScadenza);
      } else {
        sanzione.giorniAllaScadenza = " - ";
      }
    }
    // var mexError =
    //   "Attenzione " + numSanzioniInscadenza + " sanzioni in scadenza!";
    // if (numSanzioniInscadenza > 5)
    //   toast.warn(mexError, { position: toast.POSITION.TOP_RIGHT });
    // else if (numSanzioniInscadenza > 10)
    //   toast.error(mexError, { position: toast.POSITION.TOP_RIGHT });
    // else toast.info(numSanzioniInscadenza + " sanzioni in scadenza ");
    // this.setState((this.headerDataTableSanzione = resultHeader));
    // this.setState({ dataTableSanzioneCSV: resultBody });
    // this.setState({ dataTableSanzione: resultBody });
    // this.setState({ loading: false });
    if (
      this.props.location.search === "?daLav" ||
      this.props.location.search === ""
    ) {
      var mexError =
        "Attenzione " +
        numSanzioniMancanoDieciGiorni +
        " sanzioni in scadenza!";

      // if (numSanzioniMancanoDieciGiorni >= 5 )
      //   toast.warning(mexError, { position: toast.POSITION.TOP_RIGHT });
      // else if (numSanzioniMancanoDieciGiorni >= 10)
      //   toast.error(mexError, { position: toast.POSITION.TOP_RIGHT });
      // else toast.info(numSanzioniMancanoDieciGiorni + " sanzioni in scadenza ");

      switch (true) {
        case numSanzioniMancanoDieciGiorni >= 5 &&
          numSanzioniMancanoDieciGiorni <= 10:
          toast.warning(mexError, { position: toast.POSITION.TOP_RIGHT });
          break;
        case numSanzioniMancanoDieciGiorni >= 10:
          toast.error(mexError, { position: toast.POSITION.TOP_RIGHT });
          break;
        case numSanzioniMancanoDieciGiorni < 5:
          toast.info(numSanzioniMancanoDieciGiorni + " sanzioni in scadenza ");
          break;
        default:
          break;
      }
    }
    // console.log(resultBody);
    this.setState((this.headerDataTableSanzione = resultHeader));
    // this.setState({ dataTableSanzioneCSV: resultBody });
    this.setState({ dataTableSanzione: resultBody });
    this.setState({ loading: false });

    // console.log(mexError);
  }

  onRowClick(row) {
    sessionStorage.removeItem("rowSanzione");
    sessionStorage.setItem("rowSanzione", JSON.stringify(row));

    sessionStorage.removeItem("filtroDate");
    sessionStorage.setItem("filtroDate", JSON.stringify(this.state.filtro));
    toast.dismiss();
    this.props.history.push("/detailSanzione");
  }

  dataObj() {
    for (const item of this.state.dataTableSanzione) {
      item.clickEvent = () => this.onRowClick(item);
    }
    var data = {
      columns: this.headerDataTableSanzione,
      rows: this.state.dataTableSanzione,
    };
    return data;
  }

  renderTableData() {
    if (
      this.state.dataTableSanzione &&
      this.state.dataTableSanzione.length > 0
    ) {
      return (
        <CDBContainer>
          <CDBCard border>
            <div className="container">
              <div className="row">
                <div className="col">
                  <div className="col">Data Inizio: </div>
                  <div className="col">
                    <input
                      value={this.state.filtro.dataInizio}
                      type="date"
                      className="form-control"
                      onChange={this.onChangeDataInizio.bind(this)}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="col">Data Fine: </div>
                  <div className="col">
                    <input
                      value={this.state.filtro.dataFine}
                      type="date"
                      className="form-control"
                      onChange={this.onChangeDataFine.bind(this)}
                    />
                  </div>
                </div>
                <div className="col">
                  {/* <div className="col">Filtri: </div> */}
                  <br></br>
                  <div className="col">
                    <button
                      className="btn btn-warning"
                      style={{ width: "100%" }}
                      onClick={() => {
                        var search = this.props.location.search;
                        var stato = "daLav";
                        if (search != null && search.includes("?")) {
                          stato = search.substring(1, search.lenght);
                        }
                        this.getDataTable(
                          stato,
                          this.state.filtro.dataInizio,
                          this.state.filtro.dataFine
                        );
                      }}
                    >
                      Applica Filtri
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <CDBCardBody>
              <CDBDataTable
                sortable={false}
                responsiveSm={true}
                responsiveMd={true}
                responsiveLg={true}
                pagesAmount={3}
                entriesLabel={""}
                infoLabel={["Mostra da", "a", "di", "sanzioni totali"]}
                paginationLabel={["<-", "->"]}
                striped
                bordered
                hover
                checkbox
                data={this.dataObj()}
                materialSearch
              />
            </CDBCardBody>
          </CDBCard>
        </CDBContainer>
      );
    } else {
      return (
        <>
          {" "}
          <div className="row form-group">
            <div className="col">
              <div className="col">Data Inizio: </div>
              <div className="col">
                <input
                  value={this.state.filtro.dataInizio}
                  type="date"
                  className="form-control"
                  onChange={this.onChangeDataInizio.bind(this)}
                />
              </div>
            </div>
            <div className="col">
              <div className="col">Data Fine :</div>
              <div className="col">
                <input
                  value={this.state.filtro.dataFine}
                  type="date"
                  className="form-control"
                  onChange={this.onChangeDataFine.bind(this)}
                />
              </div>
            </div>
            <div className="col">
              {/* <div className="col d-none">Filtri</div> */}
              <br></br>
              <div className="col">
                <button
                  className="btn btn-warning"
                  style={{ width: "100%" }}
                  onClick={() => {
                    var search = this.props.location.search;
                    var stato = "daLav";
                    if (search != null && search.includes("?")) {
                      stato = search.substring(1, search.lenght);
                    }
                    this.getDataTable(
                      stato,
                      this.state.filtro.dataInizio,
                      this.state.filtro.dataFine
                    );
                  }}
                >
                  Applica Filtri
                </button>
              </div>
            </div>
          </div>
          <br></br>
          <h4>Nessuna Sanzione Trovata</h4>
        </>
      );
    }
  }

  addSanzione() {
    this.getTipologiaMulte();
    this.getInspectors();
    this.setState({ showModalAggiungiSanzione: true });
  }
  AnnulaAggiuntaSanzione() {
    this.setState({
      errorCFTrasgessore: false,
      errorCFTrasgessorePotesta: false,
      showModalAggiungiSanzione: false,
      anagraficaSanzionato: false,
      isMinorenne: false,
      documentiSanzionati: false,
      residenzaSanzioanto: false,
      anagraficaSanzionatoPatriaPotesta: false,
      dettagliSanzione: false,
      buttonCreaSanzione: true,
      nomeSanzionatoRequired: false,
      cognomeSanzionatoRequired: false,
    });
    this.state.creaSanzione.importo = 0;
    this.state.creaSanzione.annotazioneControllore = "";
    this.state.creaSanzione.noteTrasgressore = "";
    this.state.creaSanzione.anagraficaTrasgressore.dataDiNascita = "";
    this.state.creaSanzione.anagraficaTrasgressore.luogoDiNascita = "";
    this.state.creaSanzione.anagraficaTrasgressore.nome = "";
    this.state.creaSanzione.anagraficaTrasgressore.cognome = "";
    this.state.creaSanzione.anagraficaTrasgressore.capDiResidenza = "";
    this.state.creaSanzione.anagraficaTrasgressore.inidirizzoDiResidenza = "";
    this.state.creaSanzione.anagraficaTrasgressore.isMinorenne = 0;
    this.state.creaSanzione.anagraficaTrasgressore.numeroDocumento = "";
    this.state.creaSanzione.anagraficaTrasgressore.dataRilascioDocumento = "";
    this.state.creaSanzione.anagraficaTrasgressore.enteRilascioDocumento = "";
    this.state.creaSanzione.anagraficaTrasgressore.inidirizzoNumeroDiResidenza =
      "";
    this.state.creaSanzione.anagraficaTrasgressore.provinciaDiResidenza = "";
    this.state.creaSanzione.anagraficaTrasgressore.codiceFiscale = "";
    this.state.creaSanzione.anagraficaTrasgressore.comuneDiResidenza = "";

    this.state.creaSanzione.anagraficaPotestaTrasgressore.nome = "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.cognome = "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.dataDiNascita = "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.isMinorenne = 0;
    this.state.creaSanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento =
      "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.comuneDiResidenza =
      "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza =
      "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza =
      "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza =
      "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.capDiResidenza = "";
    this.state.creaSanzione.anagraficaPotestaTrasgressore.luogoDiNascita = "";
    this.setState({ showModalAggiungiSanzione: false });
  }

  changeTextNome(event) {
    this.state.creaSanzione.anagraficaTrasgressore.nome = capitalizeFirstLetter(
      event.target.value
    );
    this.state.nomeSanzionatoRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextCognome(event) {
    this.state.creaSanzione.anagraficaTrasgressore.cognome =
      capitalizeFirstLetter(event.target.value);
    this.state.cognomeSanzionatoRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }

  changeTextNomePatriaPotesta(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.nome =
      capitalizeFirstLetter(event.target.value);
    this.state.nomeSanzionatoPatriaPotestaRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextCognomePatriaPotesta(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.cognome =
      capitalizeFirstLetter(event.target.value);
    this.state.cognomeSanzionatoPatriaPotestaRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextLuogoNascitaPatriaPotesta(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.luogoDiNascita =
      capitalizeFirstLetter(event.target.value);
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextNumResidenzaPatriaPotesa(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza =
      event.target.value;
    this.state.numeroResidenzaSanzionatoPatriaPotestaRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }

  changeTextComuneResidenzaPatriaPotesta(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.comuneDiResidenza =
      capitalizeFirstLetter(event.target.value);
    this.state.comuneDiResidenzaSanzionatoPatriaPotestaRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }

  changeTextIndirizzoResidenzaPatriaPotesta(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza =
      capitalizeFirstLetter(event.target.value);
    this.state.indirizzoSanzionatoPatriaPotestaRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextProvinciaResidenzaPatriaPotesta(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza =
      event.target.value.toString().toUpperCase();
    this.state.provinciaSanzionatoPatriaPotestaRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextCAPResidenzaPatriaPotesta(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.capDiResidenza =
      event.target.value;
    this.state.capSanzionatoPatriaPotestaRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextDataRilascioPatriaPotesta(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento =
      event.target.value;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }

  changeTextDataNascitaPatriaPotesta(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.dataDiNascita =
      event.target.value;
    var dataOggi = new Date();
    let dataNascita = new Date(event.target.value);
    let anni = dataNascita.getFullYear();
    let anno = dataOggi.getFullYear();
    let eta = anno - anni;
    if (eta > 18) {
      //TODO rimuovere errore che e minnorenne
    } else {
      //TODO Mostrare errore che e minorenne
    }
    this.setState({ creaSanzione: this.state.creaSanzione });
  }

  changeTextTipologiaSanzione(event) {
    this.state.creaSanzione.anagraficaTipologiaSanzione.nomeViolazione =
      event.target.value;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextImporto(event) {
    // this.state.creaSanzione.importo = this.state.importoValue;
    this.state.creaSanzione.importo = event.target.value;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextTratta(event) {
    this.state.creaSanzione.tratta = event.target.value;
    this.setState({
      creaSanzione: this.state.creaSanzione,
    });
  }
  changeTextDataNascita(event) {
    this.state.creaSanzione.anagraficaTrasgressore.dataDiNascita =
      event.target.value;
    var dataOggi = new Date();
    let dataNascita = new Date(event.target.value);
    let anni = dataNascita.getFullYear();
    let anno = dataOggi.getFullYear();
    let eta = anno - anni;
    if (eta > 18) {
      this.state.isMinorenne = false;
      this.state.creaSanzione.anagraficaPotestaTrasgressore.nome = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.cognome = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.dataDiNascita = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.isMinorenne = 0;
      this.state.creaSanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.comuneDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.capDiResidenza = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.luogoDiNascita = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.codiceFiscale = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.numeroDocumento =
        "";
    } else {
      this.state.isMinorenne = true;
      this.state.comuneDiResidenzaSanzionatoRequired = false;
      this.state.indirizzoSanzionatoRequired = false;
      this.state.capSanzionatoRequired = false;
      this.state.numeroResidenzaSanzionatoRequired = false;
      this.state.provinciaSanzionatoRequired = false;
      this.state.creaSanzione.anagraficaPotestaTrasgressore.nome = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.cognome = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.dataDiNascita = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.isMinorenne = 0;
      this.state.creaSanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.comuneDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza =
        "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.capDiResidenza = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.luogoDiNascita = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.codiceFiscale = "";
      this.state.creaSanzione.anagraficaPotestaTrasgressore.numeroDocumento =
        "";
    }
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextLuogoNascita(event) {
    this.state.creaSanzione.anagraficaTrasgressore.luogoDiNascita =
      capitalizeFirstLetter(event.target.value);
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextCodiceFiscale(event) {
    this.state.creaSanzione.anagraficaTrasgressore.codiceFiscale =
      event.target.value.toString().toUpperCase();
    if (
      !validCF.test(
        this.state.creaSanzione.anagraficaTrasgressore.codiceFiscale
      )
    ) {
      this.setState({ errorCFTrasgessore: true });
    } else {
      this.setState({ errorCFTrasgessore: false });
    }
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextCodiceFiscaleP(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.codiceFiscale =
      event.target.value.toString().toUpperCase();
    if (
      !validCF.test(
        this.state.creaSanzione.anagraficaPotestaTrasgressore.codiceFiscale
      )
    ) {
      this.setState({ errorCFTrasgessorePotesta: true });
    } else {
      this.setState({ errorCFTrasgessorePotesta: false });
    }
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextNumeroDocumento(event) {
    this.state.creaSanzione.anagraficaTrasgressore.numeroDocumento =
      event.target.value.toString().toUpperCase();
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextNumeroDocumentoP(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.numeroDocumento =
      event.target.value.toString().toUpperCase();
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextDataRilascio(event) {
    this.state.creaSanzione.anagraficaTrasgressore.dataRilascioDocumento =
      event.target.value;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextEnteRilascio(event) {
    this.state.creaSanzione.anagraficaTrasgressore.enteRilascioDocumento =
      capitalizeFirstLetter(event.target.value);
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextEnteRilascioP(event) {
    this.state.creaSanzione.anagraficaPotestaTrasgressore.enteRilascioDocumento =
      capitalizeFirstLetter(event.target.value);
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextComuneResidenza(event) {
    this.state.creaSanzione.anagraficaTrasgressore.comuneDiResidenza =
      capitalizeFirstLetter(event.target.value);
    this.state.comuneDiResidenzaSanzionatoRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextIndirizzoResidenza(event) {
    this.state.creaSanzione.anagraficaTrasgressore.inidirizzoDiResidenza =
      capitalizeFirstLetter(event.target.value);
    this.state.indirizzoSanzionatoRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextNumeroResidenza(event) {
    this.state.creaSanzione.anagraficaTrasgressore.inidirizzoNumeroDiResidenza =
      event.target.value;
    this.state.numeroResidenzaSanzionatoRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextCAPResidenza(event) {
    this.state.creaSanzione.anagraficaTrasgressore.capDiResidenza =
      event.target.value;
    this.state.capSanzionatoRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextProvinciaResidenza(event) {
    this.state.creaSanzione.anagraficaTrasgressore.provinciaDiResidenza =
      event.target.value.toString().toUpperCase();
    this.state.provinciaSanzionatoRequired = false;
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextAnnotazione(event) {
    this.state.creaSanzione.annotazioneControllore = capitalizeFirstLetter(
      event.target.value
    );
    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  changeTextAnnotazioneTrasgressore(event) {
    this.state.creaSanzione.noteTrasgressore = capitalizeFirstLetter(
      event.target.value
    );
    this.setState({ creaSanzione: this.state.creaSanzione });
  }

  sectionInputMulta(event) {
    // console.log(event.target.value);
    // if (event.target.value === "0") {
    //   this.state.creaSanzione.anagraficaTipologiaSanzione.nomeViolazione =
    //     "1 Senza biglietto";
    //   this.state.creaSanzione.importo = 5800;
    // } else if (event.target.value === "1") {
    //   this.state.creaSanzione.anagraficaTipologiaSanzione.nomeViolazione =
    //     " 2 Documento di viaggio fuori tratta";
    //   this.state.creaSanzione.importo = 5300;
    // } else if (event.target.value === "2") {
    //   this.state.creaSanzione.anagraficaTipologiaSanzione.nomeViolazione =
    //     " 3 Documento di viaggio inregolare ";
    //   this.state.creaSanzione.importo = 5800;
    // } else if (event.target.value === "3") {
    //   this.state.creaSanzione.anagraficaTipologiaSanzione.nomeViolazione =
    //     " 4 Abbonamento dimenticato ";
    //   this.state.creaSanzione.importo = 5800;
    // }
    if (event.target.value === "-1") {
      this.state.anagraficaSanzionato = false;
      this.state.dettagliSanzione = false;
      this.state.creaSanzione.importo = 0;
    }
    //forse va bene
    this.state.tipologieSanzioni.map((tipoSanzione, index) => {
      if (event.target.value === tipoSanzione.nomeViolazione) {
        this.state.creaSanzione.anagraficaTipologiaSanzione.nomeViolazione =
          event.target.value;

        var arrayDiIMportoRidotto = tipoSanzione.importo.toString().split("");

        // // console.log(arrayDiIMportoRidotto[arrayDiIMportoRidotto.length - 1]);
        // if (arrayDiIMportoRidotto[arrayDiIMportoRidotto.length - 1] === "0") {
        //   this.state.creaSanzione.importo = tipoSanzione.importo + "0";
        // }else{
        this.state.creaSanzione.importo = tipoSanzione.importo;
        this.state.creaSanzione.importoRidotto = tipoSanzione.importoRidotto;
        // }

        this.state.creaSanzione.anagraficaTipologiaSanzione.idAnagrafiaTipolagiaSanzione =
          tipoSanzione.idAnagrafiaTipolagiaSanzione;
      }
    });

    this.setState({ creaSanzione: this.state.creaSanzione });
  }
  sectionInputTratta(event) {
    // console.log(event.target.value);

    if (
      event.target.value > "-1" &&
      this.state.creaSanzione.importo > 0
      // this.state.creaSanzione.anagraficaTipologiaSanzione.nomeViolazione
      //   .length > 0
    ) {
      this.state.anagraficaSanzionato = true;
      this.state.dettagliSanzione = true;
      this.state.buttonCreaSanzione = false;
    } else if (event.target.value === "-1") {
      this.state.anagraficaSanzionato = false;
      this.state.dettagliSanzione = false;
    } else if (
      this.state.creaSanzione.importo === "0" &&
      this.state.creaSanzione.importo === "0"
    ) {
      this.state.anagraficaSanzionato = false;
      this.state.dettagliSanzione = false;
    }

    // this.state.creaSanzione.localita = event.target.value;
    // console.log(this.state.creaSanzione.localita.idArea)
    /*this.state.locationsList.map((dati, index) => {
      if (parseInt(event.target.value) === index) {
        this.state.creaSanzione.localita.idArea = dati.idArea;
        this.state.creaSanzione.localita.idCliente = dati.idCliente;
        this.state.creaSanzione.localita.idLocalita = dati.idLocalita;
        this.state.creaSanzione.localita.importo = dati.importo;
        this.state.creaSanzione.localita.nomeLocalita = dati.nomeLocalita;
        this.state.creaSanzione.localita.idLinea = dati.idLinea;
      }
    });*/
    // TODO: Località here???
    this.setState({ creaSanzione: this.state.creaSanzione });
  }

  /*getLocationsList() {
    this.dashboardSanzioneService.getListLocalita((result) => {
      if (result.status === 200) {
        this.setState({ locationsList: result.data });
      }
    });
  }*/

  getInspectors() {
    this.dashboardSanzioneService.getInspectors((result) => {
      this.setState({ inspectorsList: result });
    });
  }

  showModalAggiungiSanzione(){
    return(
      <Modal size="xl" show={this.state.showModalAggiungiSanzione}>
        <Modal.Header><h1>Crea Sanzione</h1></Modal.Header>
        <Modal.Body>
          <fieldset className="border p-2 d-flex flex-column gap-2 m-2">
                <legend className="w-auto" style={{ color: "#4e73df" }}>
                  Dettagli Sanzione
                </legend>
                <div className="row">
                        <div className="col-sm-4">Data Emissione *</div>
                        <div className="col-sm-8"><input className="form-control" max={this.limitDate()} onChange={(event)=>this.newSanzioneInputHandler(event)}  name="dataDiEmissione" type="datetime-local"/></div>
                </div>
                <div className="row">
                        <div className="col-sm-4">Numero Sanzione *</div>
                        <div className="col-sm-8"><input className="form-control" maxLength={45} name="numeroSanzione" onChange={(event)=>this.newSanzioneInputHandler(event)} value={this.state.creaSanzione.numeroSanzione} type="text"/></div>
                </div>
                <div className="row">
                        <div className="col-sm-4">Linea Mezzo *</div>
                        <div className="col-sm-8"><input className="form-control" name="lineaMezzo" onChange={(event)=>this.newSanzioneInputHandler(event)} value={this.state.creaSanzione.lineaMezzo} type="text"/></div>

                </div>
                <div className="row">
                        <div className="col-sm-4">Matricola Controllore *</div>
                        <div className="col-sm-8">
                          <select
                              onChange={this.inspectorSelectorHandler.bind(this)}
                              className="form-select"
                              disabled={this.state.disableInput}
                            >
                              <option key="empty_inspector" value={""}>Seleziona una matricola</option>
                              {
                              this.state.inspectorsList.map((inspector,index) => {
                                return <option key={"inspector_"+index} value={index}>{inspector.numMatricola}</option>
                              })
                            }
                          </select>
                        </div>
                </div>

                <div className="row">
                  <div className="col-sm-4">Tipologia Sanzione *</div>
                  <div className="col-sm-8">
                    <select
                        onChange={this.tipologiaSanzioneHandler.bind(this)}
                        className="form-select"
                        disabled={this.state.disableInput}
                      >
                        <option key="empty_type" value={""}>Seleziona Tipologia</option>
                        {
                        this.state.tipologieSanzioni.map((tipologia,index) => {
                          return <option key={"type_"+index} value={index}>{tipologia.nomeViolazione}</option>
                        })
                      }
                    </select>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4">Localita' *</div>
                  <div className="col-sm-8"><input className="form-control" name="localita" onChange={(event)=>this.newSanzioneInputHandler(event)} value={this.state.creaSanzione.localita} type="text"/></div>
                </div>
                <div className="row">
                    <div className="col-sm-4">Annotazioni Controllore</div>
                    <div className="col-sm-8"><input className="form-control" name="annotazioneControllore" onChange={(event)=>{this.newSanzioneInputHandler(event)}} type="text"/></div>
                </div>
                <div className="row">
                    <div className="col-sm-4">Annotazioni Trasgressore</div>
                    <div className="col-sm-8"><input className="form-control" name="noteTrasgressore" onChange={(event)=>{this.newSanzioneInputHandler(event)}} type="text"/></div>
                </div>
                <div className="row">
                  <div className="col-sm-4">Sanzione pagata a bordo</div>
                  <div className="col-sm-8">
                  <BootstrapSwitchButton
                      checked={this.state.creaSanzione.pagataABordo} 
                      onChange={()=>this.changeSwitchHandler()} 
                      onlabel="Sanzione pagata a bordo" 
                      offlabel="Sanzione non pagata a bordo" 
                      style="w-100"/>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="">Latitudine</div>
                    <div className=""><input className="form-control"  name="lat" maxLength={35} onChange={(event)=>this.newSanzioneInputHandler(event)} value={this.state.creaSanzione.lat} type="number"/></div>
                  </div>
                  <div className="col">
                    <div className="">Longitudine</div>
                    <div className=""><input className="form-control" name="lng" maxLength={35} onChange={(event)=>this.newSanzioneInputHandler(event)} value={this.state.creaSanzione.lng} type="number"/></div>
                  </div>

                </div>

            </fieldset>
        {this.state.creaSanzione.dataDiEmissione !== ""
         && this.state.creaSanzione.dataDiEmissione < new Date()
         && this.state.creaSanzione.numeroSanzione.length >= 4 
         && this.state.creaSanzione.lineaMezzo.length >= 1
         && this.state.creaSanzione.matricolaControllore.length >= 4
         && this.state.creaSanzione.anagraficaTipologiaSanzione !==""
         && this.state.creaSanzione.localita.length >= 2
        &&(
        <fieldset className="border p-2 d-flex flex-column gap-2 m-2">
          <legend className="w-auto" style={{ color: "#4e73df" }}>Anagrafica Trasgressore</legend>
          <div className="row">
                <div className="col-sm-4">Nome *</div>
                <div className="col-sm-8"><input className="form-control" maxLength={50} name="nome" onChange={(event)=>this.newSanzioneAnagraficaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaTrasgressore.nome} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Cognome *</div>
                <div className="col-sm-8"><input className="form-control"maxLength={50} name="cognome" onChange={(event)=>this.newSanzioneAnagraficaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaTrasgressore.cognome} type="text"/></div>
          </div>
          <div className="row">
            <div className="col-sm-4">Sesso *</div>
            <div className="col-sm-8">
              <select
                  name="sesso"
                  onChange={(event) => this.sexSelectorHandler(event, false)}
                  className="form-select"
                  disabled={this.state.disableInput}
                >
                  <option key="empty_inspector" value={""}>Seleziona un valore</option>
                  {
                  this.state.sexList.map((sex,index) => {
                    return <option key={"inspector_"+index} value={index}>{sex}</option>
                  })
                }
              </select>
            </div>
          </div>
          <div className="row">
                <div className="col-sm-4">Data di nascita *</div>
                <div className="col-sm-8"><input className="form-control" max={getFormatOraInput(new Date())} name="dataDiNascita" onChange={(event)=>this.newSanzioneAnagraficaTrasgressoreInputHandler(event)} value={getFormatOraInput(this.state.creaSanzione.anagraficaTrasgressore.dataDiNascita)} type="date"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Luogo di nascita *</div>
                <div className="col-sm-8"><input className="form-control" maxLength={35} name="luogoDiNascita" onChange={(event)=>this.newSanzioneAnagraficaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaTrasgressore.luogoDiNascita} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Numero documento</div>
                <div className="col-sm-8"><input className="form-control" maxLength={50} name="numeroDocumento" onChange={(event)=>this.newSanzioneAnagraficaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaTrasgressore.numeroDocumento} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Tipo documento</div>
                <div className="col-sm-8"><input className="form-control" maxLength={50} name="tipoDocumento" onChange={(event)=>this.newSanzioneAnagraficaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaTrasgressore.tipoDocumento} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Data rilascio documento</div>
                <div className="col-sm-8"><input className="form-control" max={getFormatOraInput(new Date())} name="dataRilascioDocumento" onChange={(event)=>this.newSanzioneAnagraficaTrasgressoreInputHandler(event)} value={getFormatOraInput(this.state.creaSanzione.anagraficaTrasgressore.dataRilascioDocumento)} type="date"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Ente rilascio documento</div>
                <div className="col-sm-8"><input className="form-control" maxLength={100} name="enteRilascioDocumento" onChange={(event)=>this.newSanzioneAnagraficaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaTrasgressore.enteRilascioDocumento} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Comune di residenza {this.state.creaSanzione.anagraficaTrasgressore.isMinorenne === 1 ? "" : "*"}</div>
                <div className="col-sm-8"><input className="form-control" maxLength={35} name="comuneDiResidenza" onChange={(event)=>this.newSanzioneAnagraficaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaTrasgressore.comuneDiResidenza} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Indirizzo di residenza {this.state.creaSanzione.anagraficaTrasgressore.isMinorenne === 1 ? "" : "*"}</div>
                <div className="col-sm-8"><input className="form-control" maxLength={44} name="inidirizzoDiResidenza" onChange={(event)=>this.newSanzioneAnagraficaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaTrasgressore.inidirizzoDiResidenza} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Numero di residenza {this.state.creaSanzione.anagraficaTrasgressore.isMinorenne === 1 ? "" : "*"}</div>
                <div className="col-sm-8"><input className="form-control" maxLength={10} name="inidirizzoNumeroDiResidenza" onChange={(event)=>this.newSanzioneAnagraficaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaTrasgressore.inidirizzoNumeroDiResidenza} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Provincia</div>
                <div className="col-sm-8"><input className="form-control" maxLength={2} name="provinciaDiResidenza" onChange={(event)=>this.newSanzioneAnagraficaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaTrasgressore.provinciaDiResidenza} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">CAP</div>
                <div className="col-sm-8"><input className="form-control" maxLength={10} name="capDiResidenza" onChange={(event)=>this.newSanzioneAnagraficaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaTrasgressore.capDiResidenza} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Codice Fiscale</div>
                <div className="col-sm-8"><input className="form-control" maxLength={16} name="codiceFiscale" onChange={(event)=>this.newSanzioneAnagraficaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaTrasgressore.codiceFiscale} type="text"/></div>
          </div>
        </fieldset>
        )
        }
        {this.state.creaSanzione.dataDiEmissione !== ""
         && this.state.creaSanzione.dataDiEmissione < new Date()
         && this.state.creaSanzione.numeroSanzione.length >= 4 
         && this.state.creaSanzione.lineaMezzo.length >= 1
         && this.state.creaSanzione.matricolaControllore.length >= 4
         && this.state.creaSanzione.anagraficaTipologiaSanzione !==""
         && this.state.creaSanzione.localita.length >= 2
         && this.state.creaSanzione.anagraficaTrasgressore.isMinorenne === 1
         && this.nameRegex.test(this.state.creaSanzione.anagraficaTrasgressore.nome)
         && this.nameRegex.test(this.state.creaSanzione.anagraficaTrasgressore.cognome)
         && (this.state.creaSanzione.anagraficaTrasgressore.sesso === "F" || this.state.creaSanzione.anagraficaTrasgressore.sesso === "M")
         && this.state.creaSanzione.anagraficaTrasgressore.luogoDiNascita.length > 2
         && this.state.creaSanzione.anagraficaTrasgressore.dataDiNascita !== ""
         && this.state.creaSanzione.anagraficaTrasgressore.dataDiNascita < new Date()
         &&(
        <fieldset className="border p-2 d-flex flex-column gap-2 m-2">
          <legend className="w-auto" style={{ color: "#4e73df" }}>Anagrafica Potesta Trasgressore</legend>
          <div className="row">
                <div className="col-sm-4">Nome*</div>
                <div className="col-sm-8"><input className="form-control" maxLength={50} name="nome" onChange={(event)=>this.newSanzioneAnagraficaPotestaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaPotestaTrasgressore.nome} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Cognome*</div>
                <div className="col-sm-8"><input className="form-control"maxLength={50} name="cognome" onChange={(event)=>this.newSanzioneAnagraficaPotestaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaPotestaTrasgressore.cognome} type="text"/></div>
          </div>
          <div className="row">
            <div className="col-sm-4">Sesso</div>
            <div className="col-sm-8">
              <select
                  name="sesso"
                  onChange={(event) => this.sexSelectorHandler(event, true)}
                  className="form-select"
                  disabled={this.state.disableInput}
                >
                  <option key="empty_inspector" value={""}>Seleziona un valore</option>
                  {
                  this.state.sexList.map((sex,index) => {
                    return <option key={"inspector_"+index} value={index}>{sex}</option>
                  })
                }
              </select>
            </div>
          </div>
          <div className="row">
                <div className="col-sm-4">Data di nascita</div>
                <div className="col-sm-8"><input className="form-control" max={getFormatOraInput(new Date())} name="dataDiNascita" onChange={(event)=>this.newSanzioneAnagraficaPotestaTrasgressoreInputHandler(event)} value={getFormatOraInput(this.state.creaSanzione.anagraficaPotestaTrasgressore.dataDiNascita)} type="date"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Luogo di nascita</div>
                <div className="col-sm-8"><input className="form-control" maxLength={35} name="luogoDiNascita" onChange={(event)=>this.newSanzioneAnagraficaPotestaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaPotestaTrasgressore.luogoDiNascita} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Numero documento</div>
                <div className="col-sm-8"><input className="form-control" maxLength={50} name="numeroDocumento" onChange={(event)=>this.newSanzioneAnagraficaPotestaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaPotestaTrasgressore.numeroDocumento} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Tipo documento</div>
                <div className="col-sm-8"><input className="form-control" maxLength={50} name="tipoDocumento" onChange={(event)=>this.newSanzioneAnagraficaPotestaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaPotestaTrasgressore.tipoDocumento} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Data rilascio documento</div>
                <div className="col-sm-8"><input className="form-control" max={getFormatOraInput(new Date())} name="dataRilascioDocumento" onChange={(event)=>this.newSanzioneAnagraficaPotestaTrasgressoreInputHandler(event)} value={getFormatOraInput(this.state.creaSanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento)} type="date"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Ente rilascio documento</div>
                <div className="col-sm-8"><input className="form-control" maxLength={100} name="enteRilascioDocumento" onChange={(event)=>this.newSanzioneAnagraficaPotestaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaPotestaTrasgressore.enteRilascioDocumento} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Comune di residenza*</div>
                <div className="col-sm-8"><input className="form-control" maxLength={35} name="comuneDiResidenza" onChange={(event)=>this.newSanzioneAnagraficaPotestaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaPotestaTrasgressore.comuneDiResidenza} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Indirizzo di residenza*</div>
                <div className="col-sm-8"><input className="form-control" maxLength={44} name="inidirizzoDiResidenza" onChange={(event)=>this.newSanzioneAnagraficaPotestaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Numero di residenza*</div>
                <div className="col-sm-8"><input className="form-control" maxLength={10} name="inidirizzoNumeroDiResidenza" onChange={(event)=>this.newSanzioneAnagraficaPotestaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Provincia</div>
                <div className="col-sm-8"><input className="form-control" maxLength={2} name="provinciaDiResidenza" onChange={(event)=>this.newSanzioneAnagraficaPotestaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">CAP</div>
                <div className="col-sm-8"><input className="form-control" maxLength={10} name="capDiResidenza" onChange={(event)=>this.newSanzioneAnagraficaPotestaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaPotestaTrasgressore.capDiResidenza} type="text"/></div>
          </div>
          <div className="row">
                <div className="col-sm-4">Codice Fiscale</div>
                <div className="col-sm-8"><input className="form-control" maxLength={16} name="codiceFiscale" onChange={(event)=>this.newSanzioneAnagraficaPotestaTrasgressoreInputHandler(event)} value={this.state.creaSanzione.anagraficaPotestaTrasgressore.codiceFiscale} type="text"/></div>
          </div>
          
        </fieldset>

        )
        }

        </Modal.Body>
        <Modal.Footer>
          <Button
          onClick={()=>this.annullaNuovaSanzione()}
          >Annulla</Button>
          <Button
          disabled={this.checkDatiSanzione()}
          onClick={()=>this.confermaSanzione()}>
            Conferma
            </Button>
        </Modal.Footer>
      </Modal>
    )
  }
  limitDate(){
    let date = new Date();

    // Ottieni le parti della data
    let year = date.getFullYear(); // Anno a 4 cifre
    let month = String(date.getMonth() + 1).padStart(2, '0'); // Mese (01-12)
    let day = String(date.getDate()).padStart(2, '0'); // Giorno (01-31)
    let hours = String(date.getHours()).padStart(2, '0'); // Ore (00-23)
    let minutes = String(date.getMinutes()).padStart(2, '0'); // Minuti (00-59)

    // Formatta la data nel formato "YYYY-MM-DDTHH:MM"
    let formattedDate = year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;

    return formattedDate;
  }

  tipologiaSanzioneHandler(event){
    const {value} = event.target;

    if(value !== ""){
      this.setState({creaSanzione:{...this.state.creaSanzione, anagraficaTipologiaSanzione:this.state.tipologieSanzioni[value]}})
    }else{
      this.setState({creaSanzione:{...this.state.creaSanzione, anagraficaTipologiaSanzione:""}})
    }
  }
  
  inspectorSelectorHandler(event){
    const {value} = event.target;

    if(value !== ""){
      this.setState({creaSanzione:{...this.state.creaSanzione, matricolaControllore:this.state.inspectorsList[value].numMatricola}})
    }else{
      this.setState({creaSanzione:{...this.state.creaSanzione, matricolaControllore:""}})
    }
  }

  sexSelectorHandler(event, isPatriaPotesta){
    const {value} = event.target;

    let sexValue = value !== "" ? this.state.sexList[value] : ""

    let anagraficaTrasgressore = this.state.creaSanzione.anagraficaTrasgressore
    let anagraficaPotestaTrasgressore = this.state.creaSanzione.anagraficaPotestaTrasgressore

    if(isPatriaPotesta) {
      anagraficaPotestaTrasgressore.sesso = sexValue
    } else {
      anagraficaTrasgressore.sesso = sexValue
    }

    this.setState({creaSanzione:{...this.state.creaSanzione, anagraficaTrasgressore: anagraficaTrasgressore, anagraficaPotestaTrasgressore: anagraficaPotestaTrasgressore}})
  }

  /*locationSelectorHandler(event){
    const {value} = event.target;

    if(value !== ""){
      this.setState({creaSanzione:{...this.state.creaSanzione, localita:this.state.locationsList[value]}})
    }else{
      this.setState({creaSanzione:{...this.state.creaSanzione, localita:{
        idLocalita: 0,
        nomeLocalita: "",
        idLinea: 0,
        idArea: 0,
        idCliente: 0,
        importo: 0,
      }}})
    }
  }*/

  newSanzioneInputHandler(event){
    const {name,value} = event.target;

    if(name === "dataDiEmissione"){
      this.setState((prevState)=>({
        creaSanzione:{
          ...prevState.creaSanzione, 
          [name]:new Date(value).getTime(),
          anagraficaTrasgressore:{
            ...prevState.creaSanzione.anagraficaTrasgressore,
            isMinorenne: 0,
            dataDiNascita:""
          },
          anagraficaPotestaTrasgressore:{
            ...prevState.creaSanzione.anagraficaPotestaTrasgressore,
            isMinorenne: 0,
            dataDiNascita:""
          },
        }
      }))
    }else if(name === "lat" || name === "lng"){
      if(!isNaN(parseFloat(value))){
        this.setState((prevState)=>({creaSanzione:{...prevState.creaSanzione, [name]:parseFloat(value)}}))
      }

    }else{
      this.setState((prevState)=>({creaSanzione:{...prevState.creaSanzione, [name]:value}}))
    }


  }

  newSanzioneAnagraficaTrasgressoreInputHandler(event){
    const {name,value} = event.target;

    if(name === "dataDiNascita"){
      let date = moment(value).toDate()
      let timestamp = date.getTime();
      let verbalDate = moment(this.state.creaSanzione.dataDiEmissione).toDate();
      let timestampVerbalDate = verbalDate.getTime();

      let eighteenYearsInMilliseconds = 18 * 365 * 24 * 60 * 60 * 1000;

      let tempo = (timestampVerbalDate - timestamp) > eighteenYearsInMilliseconds;

      if (tempo) {
        this.setState({
          creaSanzione: {
            ...this.state.creaSanzione,
            anagraficaTrasgressore: {
              ...this.state.creaSanzione.anagraficaTrasgressore,
              isMinorenne: 0,
              dataDiNascita: timestamp
            }
          }
        });
      } else {
        this.setState({
          creaSanzione: {
            ...this.state.creaSanzione,
            anagraficaTrasgressore: {
              ...this.state.creaSanzione.anagraficaTrasgressore,
              isMinorenne: 1,
              dataDiNascita: timestamp
            }
          }
        });
      }
    }else if(name === "dataRilascioDocumento"){
      this.setState({
        creaSanzione: {
          ...this.state.creaSanzione,
          anagraficaTrasgressore: {
            ...this.state.creaSanzione.anagraficaTrasgressore,
            dataRilascioDocumento: moment(value).toDate().getTime()
          }
        }
      });
    }else{
      this.setState({
        creaSanzione:{
          ...this.state.creaSanzione,
          anagraficaTrasgressore:{
            ...this.state.creaSanzione.anagraficaTrasgressore,
            [name]:value
          }
        }
      })
    }
  }

  newSanzioneAnagraficaPotestaTrasgressoreInputHandler(event){
    const {name,value} = event.target;

    if(name === "dataDiNascita"){
      let date = moment(value).toDate()
      let timestamp = date.getTime();
            let verbalDate = moment(this.state.creaSanzione.dataDiEmissione).toDate();
      let timestampVerbalDate = verbalDate.getTime();

      let eighteenYearsInMilliseconds = 18 * 365 * 24 * 60 * 60 * 1000;

      let tempo = (timestampVerbalDate - timestamp) > eighteenYearsInMilliseconds;


      if (tempo) {
        this.setState({
          creaSanzione: {
            ...this.state.creaSanzione,
            anagraficaPotestaTrasgressore: {
              ...this.state.creaSanzione.anagraficaPotestaTrasgressore,
              isMinorenne: 0,
              dataDiNascita: timestamp
            }
          }
        });
      } else {
        this.setState({
          creaSanzione: {
            ...this.state.creaSanzione,
            anagraficaPotestaTrasgressore: {
              ...this.state.creaSanzione.anagraficaPotestaTrasgressore,
              isMinorenne: 1,
              dataDiNascita: timestamp
            }
          }
        });
      }
    }else if(name === "dataRilascioDocumento"){
        this.setState({
          creaSanzione: {
            ...this.state.creaSanzione,
            anagraficaPotestaTrasgressore: {
              ...this.state.creaSanzione.anagraficaPotestaTrasgressore,
              dataRilascioDocumento: moment(value).toDate().getTime()
            }
          }
        });
    }else{
      this.setState({
        creaSanzione:{
          ...this.state.creaSanzione,
          anagraficaPotestaTrasgressore:{
            ...this.state.creaSanzione.anagraficaPotestaTrasgressore,
            [name]:value
          }
        }
      })
    }

  }

  changeSwitchHandler(){
    this.setState({creaSanzione:{
      ...this.state.creaSanzione,
      pagataABordo: !this.state.creaSanzione.pagataABordo
    }})
  }

  checkDatiSanzione(){
    if(this.state.creaSanzione.anagraficaTrasgressore.isMinorenne === 1){
      if(this.nameRegex.test(this.state.creaSanzione.anagraficaTrasgressore.nome)
        && this.nameRegex.test(this.state.creaSanzione.anagraficaTrasgressore.cognome)
        && (this.state.creaSanzione.anagraficaTrasgressore.sesso === "F" || this.state.creaSanzione.anagraficaTrasgressore.sesso === "M")
        && this.state.creaSanzione.anagraficaTrasgressore.luogoDiNascita !== ""
        && this.state.creaSanzione.anagraficaTrasgressore.dataDiNascita !==""
        && this.state.creaSanzione.anagraficaTrasgressore.dataDiNascita < new Date()
        && this.state.creaSanzione.anagraficaPotestaTrasgressore.comuneDiResidenza.length > 1
        && this.nameRegex.test(this.state.creaSanzione.anagraficaPotestaTrasgressore.nome)
        && this.nameRegex.test(this.state.creaSanzione.anagraficaPotestaTrasgressore.cognome)
        && this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza
        && this.state.creaSanzione.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza.length > 0
      ){
        return false
      }else{
        return true
      }
    }else{

      if(this.nameRegex.test(this.state.creaSanzione.anagraficaTrasgressore.nome)
        && this.nameRegex.test(this.state.creaSanzione.anagraficaTrasgressore.cognome)
        && (this.state.creaSanzione.anagraficaTrasgressore.sesso === "F" || this.state.creaSanzione.anagraficaTrasgressore.sesso === "M")
        && this.state.creaSanzione.anagraficaTrasgressore.luogoDiNascita !== ""
        && this.state.creaSanzione.anagraficaTrasgressore.dataDiNascita !==""
        && this.state.creaSanzione.anagraficaTrasgressore.dataDiNascita < new Date()
        && this.state.creaSanzione.anagraficaTrasgressore.comuneDiResidenza.length > 1
        && this.state.creaSanzione.anagraficaTrasgressore.inidirizzoDiResidenza.length > 1
        && this.state.creaSanzione.anagraficaTrasgressore.inidirizzoNumeroDiResidenza.length > 0
      ){
        return false
      }else{
        return true
      }
    }

  }

  annullaNuovaSanzione(){
    this.setState({creaSanzione:{
      anagraficaTrasgressore: {
        nome: "",
        cognome: "",
        sesso: "",
        dataDiNascita: "",
        luogoDiNascita: "",
        isMinorenne: 0,
        numeroDocumento: "",
        dataRilascioDocumento: "",
        enteRilascioDocumento: "",
        comuneDiResidenza: "",
        inidirizzoDiResidenza: "",
        inidirizzoNumeroDiResidenza: "",
        provinciaDiResidenza: "",
        capDiResidenza: "",
        codiceFiscale: "",
      },
      anagraficaPotestaTrasgressore: {
        nome: "",
        cognome: "",
        sesso: "",
        dataDiNascita: "",
        luogoDiNascita: "",
        isMinorenne: 0,
        numeroDocumento: "",
        dataRilascioDocumento: "",
        enteRilascioDocumento: "",
        comuneDiResidenza: "",
        inidirizzoDiResidenza: "",
        inidirizzoNumeroDiResidenza: "",
        provinciaDiResidenza: "",
        capDiResidenza: "",
        codiceFiscale: "",
      },
      anagraficaTipologiaSanzione:"",
      localita: "",
      anagraficaStati: { idStato: 1, nomeStato: "caricato" },
      matricolaControllore: "",
      lineaMezzo:"",
      numeroSanzione:"",
      importo: 0,
      importoRidotto: 0,
      importoTitoloDiViaggio:0,
      lat:0.0,
      lng:0.0,
      dataDiEmissione:"",
      annotazioneControllore: "",
      noteTrasgressore: "",
      pagataABordo: false,
      clienti:{
        idCliente: 1,
        attivo: 1,
      },
      spacchettato:""
    },})
    this.setState({showModalAggiungiSanzione:false})
  }

  confermaSanzione(){

    let obj = {
      listaSpacchettati:[
        //{descrizione:"METCALC",valore:"MC1"},
        {descrizione:"SZ_RID", valore: this.state.spacchettato.SZ_RID},
        {descrizione:"SZ", valore: this.state.spacchettato.SZ},
        {descrizione:"SZ_INT", valore: this.state.spacchettato.SZ_INT}
      ]
    }

    if(this.state.creaSanzione.pagataABordo) {
      this.state.creaSanzione.anagraficaStati = { idStato: 7, nomeStato: "pagato" }
    } else {
      this.state.creaSanzione.anagraficaStati = { idStato: 1, nomeStato: "caricato" }
    }

    this.setState((prevState)=>({creaSanzione:{...prevState.creaSanzione,importo: prevState.spacchettato.SZ,importoRidotto: this.state.spacchettato.SZ_RID,spacchettato:JSON.stringify(obj)}}))

    /*if(this.state.creaSanzione.anagraficaTrasgressore.capDiResidenza === "" || this.state.creaSanzione.anagraficaTrasgressore.capDiResidenza.length <5 ){
      this.setState((prevState)=>({creaSanzione:{...prevState.creaSanzione,anagraficaTrasgressore:{...prevState.creaSanzione.anagraficaTrasgressore,capDiResidenza:"00000"}}}))
    }

    if(this.state.creaSanzione.anagraficaTrasgressore.provinciaDiResidenza === "" || this.state.creaSanzione.anagraficaTrasgressore.provinciaDiResidenza.length < 2){
      this.setState((prevState)=>({creaSanzione:{...prevState.creaSanzione,anagraficaTrasgressore:{...prevState.creaSanzione.anagraficaTrasgressore,provinciaDiResidenza:"00"}}}))
    }

    if(this.state.creaSanzione.anagraficaTrasgressore.isMinorenne === 1){
      if(this.state.creaSanzione.anagraficaPotestaTrasgressore.capDiResidenza === "" || this.state.creaSanzione.anagraficaPotestaTrasgressore.capDiResidenza.length <5 ){
        this.setState((prevState)=>({creaSanzione:{...prevState.creaSanzione,anagraficaPotestaTrasgressore:{...prevState.creaSanzione.anagraficaPotestaTrasgressore,capDiResidenza:"00000"}}}))
      }
  
      if(this.state.creaSanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza === "" || this.state.creaSanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza.length < 2){
        this.setState((prevState)=>({creaSanzione:{...prevState.creaSanzione,anagraficaPotestaTrasgressore:{...prevState.creaSanzione.anagraficaPotestaTrasgressore,provinciaDiResidenza:"00"}}}))
      }
    }*/

    this.setState({showModalAggiungiSanzione:false})
    this.setState({showModalConfermaSanzione:true})

  }

  modalConfermaSanzione(){
    return(
    <Modal size="sm" show={this.state.showModalConfermaSanzione}>
      <Modal.Header>Conferma Sanzione</Modal.Header>
      <Modal.Body>
        Confermi l'invio della sanzione?
      </Modal.Body>
      <Modal.Footer>
        <Button
        onClick={()=>{
          this.setState({showModalConfermaSanzione:false})
          this.annullaNuovaSanzione()
        }}>
          Annulla
        </Button>
        <Button
        onClick={()=>this.inviaSanzione()}>
          {this.state.loadingButton ? <LoadSpinner/> : "Conferma"}
        </Button>
      </Modal.Footer>

    </Modal>
    )
  }

  inviaSanzione(){
    this.setState({loadingButton:true})
    this.dashboardSanzioneService.saveFine(this.state.creaSanzione,(result)=>{
      
      toast.success("Sanzione Inviata")
      setTimeout(()=>window.location.reload(),3000);
      this.setState({
        loadingButton:false,
        showModalConfermaSanzione:false
      })
      this.setState({creaSanzione:{
        anagraficaTrasgressore: {
          nome: "",
          cognome: "",
          sesso: "",
          dataDiNascita: "",
          luogoDiNascita: "",
          isMinorenne: 0,
          numeroDocumento: "",
          dataRilascioDocumento: "",
          enteRilascioDocumento: "",
          comuneDiResidenza: "",
          inidirizzoDiResidenza: "",
          inidirizzoNumeroDiResidenza: "",
          provinciaDiResidenza: "",
          capDiResidenza: "",
          codiceFiscale: "",
        },
        anagraficaPotestaTrasgressore: {
          nome: "",
          cognome: "",
          sesso: "",
          dataDiNascita: "",
          luogoDiNascita: "",
          isMinorenne: 0,
          numeroDocumento: "",
          dataRilascioDocumento: "",
          enteRilascioDocumento: "",
          comuneDiResidenza: "",
          inidirizzoDiResidenza: "",
          inidirizzoNumeroDiResidenza: "",
          provinciaDiResidenza: "",
          capDiResidenza: "",
          codiceFiscale: "",
        },
        anagraficaTipologiaSanzione:"",
        localita:"",
        anagraficaStati: { idStato: 1, nomeStato: "caricato" },
        matricolaControllore: "",
        lineaMezzo:"",
        numeroSanzione:"",
        importo: 0,
        importoRidotto: 0,
        importoTitoloDiViaggio:0,
        lat:0.0,
        lng:0.0,
        dataDiEmissione:"",
        annotazioneControllore: "",
        noteTrasgressore: "",
        pagataABordo: false,
        clienti:{
          idCliente: 1,
          attivo: 1,
        },
        spacchettato:""
      },})
    },
    (error)=>{
      this.setState({
        loadingButton:false,
        showModalConfermaSanzione:false
      })
      this.setState({creaSanzione:{
        anagraficaTrasgressore: {
          nome: "",
          cognome: "",
          sesso: "",
          dataDiNascita: "",
          luogoDiNascita: "",
          isMinorenne: 0,
          numeroDocumento: "",
          dataRilascioDocumento: "",
          enteRilascioDocumento: "",
          comuneDiResidenza: "",
          inidirizzoDiResidenza: "",
          inidirizzoNumeroDiResidenza: "",
          provinciaDiResidenza: "",
          capDiResidenza: "",
          codiceFiscale: "",
        },
        anagraficaPotestaTrasgressore: {
          nome: "",
          cognome: "",
          dataDiNascita: "",
          luogoDiNascita: "",
          isMinorenne: 0,
          numeroDocumento: "",
          dataRilascioDocumento: "",
          enteRilascioDocumento: "",
          comuneDiResidenza: "",
          inidirizzoDiResidenza: "",
          inidirizzoNumeroDiResidenza: "",
          provinciaDiResidenza: "",
          capDiResidenza: "",
          codiceFiscale: "",
        },
        anagraficaTipologiaSanzione:"",
        localita:"",
        anagraficaStati: { idStato: 1, nomeStato: "caricato" },
        matricolaControllore: "",
        lineaMezzo:"",
        numeroSanzione:"",
        importo: 0,
        importoRidotto: 0,
        importoTitoloDiViaggio:0,
        lat:0.0,
        lng:0.0,
        dataDiEmissione:"",
        annotazioneControllore: "",
        noteTrasgressore: "",
        pagataABordo: false,
        clienti:{
          idCliente: 1,
          attivo: 1,
        },
        spacchettato:""
      },})
      toast.error("Qualcosa e' andato storto, Riprova piu tardi")
    })
  }

  onChangeDataInizio(event) {
    this.state.filtro.dataInizio = event.target.value;
    this.setState({ filtro: this.state.filtro });
  }

  onChangeDataFine(event) {
    this.state.filtro.dataFine = event.target.value;
    this.setState({ filtro: this.state.filtro });

    // var search = this.props.location.search;
    // var stato = "daLav";
    // if (search != null && search.includes("?")) {
    //   stato = search.substring(1, search.lenght);
    // }
    // this.getDataTable(
    //   stato,
    //   this.state.filtro.dataInizio,
    //   this.state.filtro.dataFine
    // );
  }

  render() {
    // const params = new URLSearchParams(this.props.location.search);
    // console.log(params)
    var search = this.props.location.search;
    var stato = "daLav";
    if (search != null && search.includes("?")) {
      stato = search.substring(1, search.lenght);
    }
    // console.log(stato)

    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <div id="wrapper">
        <Menucustom />
        <div className="container-fluid">
          <br />
          <br />
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h1 mb-2 text-gray-800">
              Gestione Sanzioni<br></br>
              <small
                style={{ fontSize: "14px" }}
                className="mb-2 text-gray-800"
              >
                Sanzioni &#8594;{" "}
                {stato === "daLav"
                  ? "Da Lavorare"
                  : stato === "inLav"
                  ? "In Lavorazione"
                  : stato === "pagate"
                  ? "Pagate"
                  : stato === "ravvedimentoOperoso"
                  ? "Ravvedimento Operoso"
                  : stato === "agliAtti"
                  ? "Agli Atti"
                  : stato === "annullate"
                  ? "Annullate"
                  : stato === "altri"
                  ? "Altri"
                  : stato === "rateizzati"
                  ? "Rateizzati"
                  : stato === "postalizzate"
                  ? "Postalizzate"
                  : ""}
              </small>
            </h1>
            <button
              type="button"
              class="btn btn-warning"
              onClick={this.addSanzione.bind(this)}
            >
              {" "}
              <i className="fas fa-plus fa-sm text-white"></i> &nbsp;Aggiungi
              sanzione
            </button>
            {/* onClick={this.onClickCSVDownLoad.bind(this)} */}
            <button
              type="button"
              class="btn btn-warning"
              onClick={this.onClickCSVDownLoad.bind(this)}
            >
              {" "}
              <i className="fas fa-download fa-sm text-white"></i> &nbsp;Esporta
              Sanzioni
            </button>
            <CSVLink
              data={this.state.dataTableSanzioneCSVLoad}
              separator={";"}
              // onClick={this.onClickCSVDownLoad.bind(this)}
              ref={this.csvLinkEl}
              filename={
                stato === "daLav"
                  ? "Da Lavorare.csv"
                  : stato === "inLav"
                  ? "In Lavorazione.csv"
                  : stato === "pagate"
                  ? "Pagate.csv"
                  : stato === "ravvedimentoOperoso"
                  ? "Ravvedimento Operoso.csv"
                  : stato === "agliAtti"
                  ? "Agli Atti.csv"
                  : stato === "annullate"
                  ? "Annullate.csv"
                  : stato === "altri"
                  ? "Altri.csv"
                  : ""
              }
            />
            {this.showModalAggiungiSanzione()}
            {this.modalConfermaSanzione()}
            {/* </CSVLink> */}
          </div>
          {/* <br />
          <br /> */}

          <div className="col">{this.renderTableData()}</div>
        </div>
      </div>
    );
    return <div>{content}</div>;
  }
}
export default withRouter(Home);